import {Auth} from 'aws-amplify';
import {host} from '../data.js'

const LOCATION_ERROR_MESSAGE =
    'Error in user settings data service! Provide data to the service!';

let urlConfig = {
    api: '/user/settingsdata',
    //proxyPort: 5000
}

export const userSettingsData = {
    getUserSettingsData: async () => {
        try {
                        
            const url = host + urlConfig.api;
            const user = await Auth.currentAuthenticatedUser();

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: user?.signInUserSession?.idToken?.jwtToken,
                },
            });

            const data = await response.json();
            
            return {status: response.status, data};
        } catch (error) {
            console.error(LOCATION_ERROR_MESSAGE, error);
        }
    },
    updateUserSettingsData: async (settingsData) => {
        try {
            if (!settingsData) {
                return console.error(LOCATION_ERROR_MESSAGE);
            }
            
            const url = host + urlConfig.api;
            const user = await Auth.currentAuthenticatedUser();
            
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: user?.signInUserSession?.idToken?.jwtToken,
                },
                body: JSON.stringify(settingsData),
            });

            const data = await response.json();
            return {status: response.status, data};
        } catch (error) {
            console.error(LOCATION_ERROR_MESSAGE, error);
        }
    },
    formatSettings: (settings_name, data) => {
        var out = {}
        out[settings_name] = data;
        return out;
    }
};
